import { Form, InputNumber, Modal, Table } from 'antd'
import { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const DetailsAvenant = (props) => {
    const [form] = Form.useForm();
    const [modalData, setModalData] = useState([]);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [modalDetails, setModalDetails] = useState(false);

    useEffect(() => {
        const md = props?.categories?.map(cat => {
            // console.log('cat:', cat);
            const existingAvenantDetails = props?.avenant?.detailsAvenant?.filter((detail) => detail.categorie.codeCategorie === cat.codeCategorie);
            // console.log('existingRate:', existingAvenantDetails);
            return {
                detailsAvenantId: existingAvenantDetails && existingAvenantDetails[0]?.detailsAvenantId || `${cat.codeCategorie}`,
                categorie: cat,
                accessoires: existingAvenantDetails && existingAvenantDetails[0]?.accessoires ? existingAvenantDetails[0]?.accessoires : 0,
            };
        });

        // Mettez à jour l'état pour afficher le modal et y passer les données
        setModalData(md);
    }, [props?.avenant?.detailsAvenant, props?.avenant, props?.open]);

    useEffect(() => {
        setModalDetails(props?.open);
    }, [props?.open]);

    const handleSubmit = () => {
        // appel API save/update contrat handleShowDetails(record)
        setDetailsLoading(true);
        // Verifier dans le modalData si detailsAvenantId, n'est pas un nombre, mettre null
        modalData.forEach(item => {
            if (isNaN(item.detailsAvenantId)) {
                item.detailsAvenantId = null;
            }
        })
        const av = {
            ...props?.avenant,
            detailsAvenant: modalData
        }
        // console.log("modalData: ", modalData);
        axiosInstance.put(`/api/avenant/details`, av).then((res) => {
            toast("Informations mises à jour avec succès!");
            setDetailsLoading(false);
            props.setOpen(false);
        }).catch((err) => {
            console.log(err);
            setDetailsLoading(false);
        })
    };

    useEffect(() => {
        if (modalData && modalData.length > 0) {
            form.resetFields();
            form.setFieldsValue(
                Object.fromEntries(modalData.map(item => [item.categorie.categorieId, item.accessoires]))
            );
        }
    }, [modalData, form]);


    return (
        <Modal
            title={`Enregistrer les détails de l'avenant ${props?.avenant?.nom.toUpperCase()} (${props?.avenant?.code})`}
            centered
            open={modalDetails}
            onOk={() => handleSubmit()}
            onCancel={() => props.setOpen(false)}
            loading={detailsLoading}
            confirmLoading={detailsLoading}
            width={600}
            okText={"Enregistrer"}
            cancelText="Annuler"
        >
            <Form form={form}>
                <Table
                    dataSource={modalData}
                    pagination={false}
                    rowKey={record => record.categorie.categorieId}
                    columns={[
                        {
                            title: 'Catégorie',
                            dataIndex: 'categorie',
                            key: 'categorie',
                            render: (cat) => <span className="badge bg-secondary">{cat?.nom ?? cat?.libelle ?? 'N/A'}</span>,
                        },
                        {
                            title: 'Accessoires',
                            dataIndex: 'accessoires',
                            key: 'accessoires',
                            render: (value, record) => (
                                <Form.Item
                                    name={record.categorie.categorieId}
                                    style={{ margin: 0 }}
                                    rules={[{ required: true, message: 'Les frais accessoires sont obligatoires' }]}
                                >
                                    <InputNumber value={value} min={0} style={{ width: '100%' }} onChange={(value) => record.accessoires = value} />
                                </Form.Item>
                            ),
                        },
                    ]}
                />
            </Form>
        </Modal>
    )
}

DetailsAvenant.propTypes = {
    open: PropTypes.bool,
    avenant: PropTypes.object,
    categories: PropTypes.array,
    setOpen: PropTypes.func,
};

export default DetailsAvenant